import { render, staticRenderFns } from "./RegistroDocentes.vue?vue&type=template&id=50c0a0d4"
import script from "./RegistroDocentes.vue?vue&type=script&lang=js"
export * from "./RegistroDocentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports